import { Grid, Typography } from "@mui/material"
import React, { useEffect, useState, useCallback } from "react"
import ContestTable from "./components/ContestTable"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { useHistory } from "react-router-dom"
import { createBreadcrumbs } from "../../../../helpers/breadCrumbs"
import { useDispatch, useSelector } from "react-redux"
import {
  getLastWeeklyChallengeAction,
  getNextWeeklyChallengeAction,
  getPreviousToLastWeeklyChallengeAction,
  getWeeklyChallengeAction
} from "redux/marketing/actions"
import { setupWeeklyChallengesAction } from "redux/marketing/actions/user"
import { getMonthWithOffset } from "helpers/functions"
import { marketingActions } from "redux/marketing/slice/user"
import GenerateChallengeModal from "./components/GenerateChallengeModal"
import styles from "./PendingQuestionTable.module.scss"

const WeeklyChallenge = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {
    weeklyChallengeList,
    nextWeeklyChallengeList,
    lastWeeklyChallengeList,
    previousToLastWeeklyChallengeList,
    statusChanged
  } = useSelector((state) => state?.marketing)
  const { isLoading } = useSelector((store) => store.app)

  const refetchChallengeLists = useCallback(() => {
    const nextMonth = getMonthWithOffset(1)
    const currentMonth = getMonthWithOffset(0)
    const lastMonth = getMonthWithOffset(-1)
    const previousToLastMonth = getMonthWithOffset(-2)

    dispatch(getWeeklyChallengeAction({ month: currentMonth }))
    dispatch(getNextWeeklyChallengeAction({ month: nextMonth }))
    dispatch(getLastWeeklyChallengeAction({ month: lastMonth }))
    dispatch(getPreviousToLastWeeklyChallengeAction({ month: previousToLastMonth }))
  }, [])

  useEffect(() => {
    document.title = "Weekly Challenge"
    setBreadcrumbs(createBreadcrumbs())
    refetchChallengeLists()
    dispatch(marketingActions.setStatusChanged(false))
  }, [statusChanged, refetchChallengeLists])

  const handleQuestionBank = () => {
    history.push("/learning_development/dashboard/weekly-question-bank")
  }

  const handleWeeklyQuiz = () => {
    history.push("/learning_development/dashboard/weekly-challenge/weekly-quiz")
  }

  const handleGenerateChallenge = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const handleModalSubmit = (payload) => {
    dispatch(
      setupWeeklyChallengesAction({
        ...payload,
        onSuccess: refetchChallengeLists
      })
    )
    setIsModalOpen(false)
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Header title="Weekly Challenge" breadCrumbs={breadcrumbs}>
          <AppButton onClick={handleGenerateChallenge} className={styles.btnQuestion}>
            Generate Challenge
          </AppButton>
          <AppButton onClick={() => handleWeeklyQuiz()} className={styles.btnQuestion}>
            Weekly Quiz
          </AppButton>
          <AppButton onClick={() => handleQuestionBank()} className={styles.btnQuestion}>
            Question Bank
          </AppButton>
        </Header>
      </Grid>
      <Grid container direction={"column"}>
        {weeklyChallengeList?.length ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={styles.heading} variant="h2">
                {new Date(new Date().setMonth(new Date().getMonth() + 1)).toLocaleString(
                  "default",
                  {
                    month: "long",
                    year: "numeric"
                  }
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ContestTable
                weeklyChallengeList={nextWeeklyChallengeList}
                previousWeeklyChallengeList={[
                  ...(weeklyChallengeList ?? []),
                  ...(lastWeeklyChallengeList ?? []),
                  ...(previousToLastWeeklyChallengeList ?? [])
                ]}
                isLoading={isLoading}
                enableRepeatActions
                onRepeatSuccess={refetchChallengeLists}
              />
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography sx={styles.heading} variant="h2">
              {new Date().toLocaleString("default", { month: "long", year: "numeric" })}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable
              weeklyChallengeList={weeklyChallengeList}
              previousWeeklyChallengeList={[
                ...(lastWeeklyChallengeList ?? []),
                ...(previousToLastWeeklyChallengeList ?? [])
              ]}
              isLoading={isLoading}
              enableRepeatActions
              onRepeatSuccess={refetchChallengeLists}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography sx={styles.heading} variant="h2">
              {new Date(new Date().getFullYear(), new Date().getMonth() - 1).toLocaleString(
                "default",
                {
                  month: "long",
                  year: "numeric"
                }
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable weeklyChallengeList={lastWeeklyChallengeList} isLoading={isLoading} />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography sx={styles.heading} variant="h2">
              {new Date(new Date().setMonth(new Date().getMonth() - 2)).toLocaleString("default", {
                month: "long",
                year: "numeric"
              })}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable
              weeklyChallengeList={previousToLastWeeklyChallengeList}
              isLoading={isLoading}
            />
          </Grid>
        </Grid>
      </Grid>
      <GenerateChallengeModal
        open={isModalOpen}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
        isLoading={isLoading}
      />
    </Grid>
  )
}

export default WeeklyChallenge
